import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import 'assets/css/styles.css';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);